export default {
  GLOBAL_SOCKET_STATE: 'GLOBAL_SOCKET_STATE',
  GLOBAL_MINIMIZE_APP: 'GLOBAL_MINIMIZE_APP', // isMinimize
  GLOBAL_CALL_STATE: 'GLOBAL_CALL_STATE', // onCall
  GLOBAL_TAB_STATE: 'GLOBAL_TAB_STATE', // selectedTab
  GLOBAL_STATE: 'GLOBAL_STATE', // state
  GLOBAL_STATE_CHANGE: 'GLOBAL_STATE_CHANGE', // team
  GLOBAL_DYNAMIC_UPDATE: 'GLOBAL_DYNAMIC_UPDATE', // global dynamic variable change
  GLOBAL_BALANCE_UPDATE: 'GLOBAL_BALANCE_UPDATE', // global dynamic balance change

  ONLINE_CALL_LIST: 'ONLINE_CALL_LIST', // callList
  ONLINE_TEAM: 'ONLINE_TEAM', // team

  SET_BREAK_LIST: 'SET_BREAK_LIST', // SET_BREAK_LIST
  GET_BREAK_LIST: 'GET_BREAK_LIST', // GET_BREAK_LIST

  PROFILE_TEAM_LIST: 'PROFILE_TEAM_LIST', // teamList
  PROFILE_TEAM: 'PROFILE_TEAM', // team

  CALL_INFO: 'CALL_INFO', // callInfo
  CALL_List: 'CALL_List', // List
  CALL_CUSTOMER_NUMBER: 'CALL_CUSTOMER_NUMBER', // customerNumber
  CALL_CUSTOMER_NAME: 'CALL_CUSTOMER_NAME', // customerName
  CALL_START_TIME: 'CALL_START_TIME', // startTime
  CALL_CURRENT_TIME: 'CALL_CURRENT_TIME', // currentTime

  LIVE_AGENT_LIST: "LIVE_AGENT_LIST",
  LIVE_FILTER: "LIVE_FILTER",
  LIVE_STATE_LIST: "LIVE_STATE_LIST",
  LIVE_QUEUE: "LIVE_QUEUE",
  LIVE_SET_AGENT_LIST: "LIVE_SET_AGENT_LIST",
  LIVE_SET_FILTER: "LIVE_SET_FILTER",
  LIVE_SET_STATE_LIST: "LIVE_SET_STATE_LIST",
  LIVE_SET_QUEUE: "LIVE_SET_QUEUE",
  LIVE_DYNAMIC_UPDATE: "LIVE_DYNAMIC_UPDATE",
};



// WEBPACK FOOTER //
// ./src/store/actionTypes/index.js